
<div class="pg-pc">
  <div class="qrcode"></div>
  <!-- <div class="text">请使用手机微信扫码访问</div> -->
</div>
